export type TrialStatus = 'ATIVO' | 'EXPIRADO' | 'ENCERRADO' | 'CONVERTIDO';

export type TrialAction =
  | 'CRIACAO'
  | 'EXTENSAO'
  | 'CONVERSAO'
  | 'ENCERRAMENTO_MANUAL'
  | 'BLOQUEIO_AUTOMATICO'
  | 'APROVACAO_REATIVACAO';

export interface TrialHistoryEntry {
  id: string;
  acao: TrialAction;
  usuarioId: string | null;
  usuarioNome: string | null;
  dataHora: string;
  motivo: string | null;
  dataExpiracaoAnterior: string | null;
  dataExpiracaoNova: string | null;
  contratosCriadosIds: string[] | null;
}

export type TrialProductBehavior = 'FREE' | 'CHARGE' | 'BLOCK';

export interface TrialTenant {
  id: string;
  rootContractId: string;
  tenantId: string;
  tenantNome: string;
  tenantEmail: string | null;
  produtoId: string;
  produtoNome: string;
  produtoTrialDays: number | null;
  produtoTrialBehavior: TrialProductBehavior | null;
  status: TrialStatus;
  dataInicio: string;
  dataExpiracao: string;
  alertaVencimentoDias: number | null;
  observacao: string | null;
  motivoEncerramento: string | null;
  criadoPor: string | null;
  criadoEm: string;
  atualizadoEm: string;
  historico: TrialHistoryEntry[];
}

export interface ProdutoSnapshot {
  nome: string;
  trialDays: number | null;
  trialBehavior: TrialProductBehavior | null;
}

export type PaymentMethodOption = 'PIX' | 'BOLETO' | 'CARTAO';

export interface IniciarTrialFormData {
  tenantId: string;
  produtoId: string;
  produtoSnapshot: ProdutoSnapshot;
  dataInicio: string;
  dataExpiracao: string;
  alertaVencimentoDias: number | null;
  observacao: string | null;
  metodoPagamento: PaymentMethodOption;
  diaVencimento: number;
}

export interface EstenderTrialFormData {
  trialId: string;
  novaDataExpiracao: string;
  motivo: string;
}

export interface ConverterTrialFormData {
  trialId: string;
  produtosVinculadosIds: string[];
}

export interface EncerrarTrialFormData {
  trialId: string;
  motivo: string | null;
  cienteIrreversivel: boolean;
}

export interface AprovarReativacaoFormData {
  tenantId: string;
  justificativa: string;
}

export interface TrialListFilters {
  status: TrialStatus[];
  dataExpiracaoInicio: string | null;
  dataExpiracaoFim: string | null;
  busca: string;
}

export interface TrialListSummary {
  totalAtivos: number;
  vencendoEmAteSeteDias: number;
  expiradosSemAcao: number;
  convertidosNoMes: number;
}

export interface TrialsState {
  trials: TrialTenant[];
  summary: TrialListSummary;
  filters: TrialListFilters;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

export const DEFAULT_TRIAL_FILTERS: TrialListFilters = {
  status: [],
  dataExpiracaoInicio: null,
  dataExpiracaoFim: null,
  busca: '',
};

export const DEFAULT_TRIAL_SUMMARY: TrialListSummary = {
  totalAtivos: 0,
  vencendoEmAteSeteDias: 0,
  expiradosSemAcao: 0,
  convertidosNoMes: 0,
};
